import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { memo } from 'react';
import { TaskRecord } from '../types';

interface DayRecordsTableProps {
  records: TaskRecord[];
  date: string;
}

const DayRecordsTable = memo(({ records, date }: DayRecordsTableProps) => {
  return (
    <div className="p-4">
      <h3 className="text-lg font-semibold mb-4">Records for {date}</h3>
      <div className="-mx-2">
        <Table>
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              <TableHead className="h-7 text-xs font-medium">Name</TableHead>
              <TableHead className="text-right h-7 text-xs font-medium">Income</TableHead>
              <TableHead className="text-right h-7 text-xs font-medium">Supplies</TableHead>
              <TableHead className="text-right h-7 text-xs font-medium">Turn</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {records.map((record, index) => (
              <TableRow key={`${record.name}-${index}`} className="hover:bg-gray-200/60">
                <TableCell className="py-1.5 text-sm">{record.name}</TableCell>
                <TableCell className="text-right py-1.5 text-sm">
                  {record.income.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </TableCell>
                <TableCell className="text-right py-1.5 text-sm">
                  {record.supplies.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </TableCell>
                <TableCell className="text-right py-1.5 text-sm">{record.credits}</TableCell>
              </TableRow>
            ))}
            {records.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} className="text-center text-sm text-gray-500">
                  No records found for this day
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
});

DayRecordsTable.displayName = 'DayRecordsTable';
export default DayRecordsTable;
